<template>
  <a-modal
    :visible="true"
    title="Importar plantilla"
    width="600px"
    centered
    wrapClassName="import-template-modal"
    :body-style="{ padding: '12px 24px' }"
    :mask-closable="false"
    :keyboard="false"
    @cancel="handleConfirmationClose"
  >
    <p>Selecciona las opciones donde quieres importar tus contactos o productos direccionados.</p>

    <a-form ref="formRef" :model="formState" :rules="rules" class="form" layout="vertical">
      <a-row :gutter="16" class="container__group">
        <a-col :span="24">
          <a-form-item label="Empresa" name="entity" v-if="isTypeBusiness === false">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.entity"
              placeholder="Seleccione una empresa"
              @change="handleEntityChange"
            >
              <a-select-option v-for="item in entities" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="user?.customer.enable_bases === true">
          <a-form-item label="Campaña" name="portfolio">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.portfolio"
              placeholder="Seleccione una campaña"
              @change="handlePortfolioChange"
            >
              <a-select-option v-for="item in portfolios" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-if="user?.customer.enable_bases === false">
          <a-form-item label="Campaña" name="portfolio">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.portfolio"
              placeholder="Seleccione una campaña"
              @change="handlePortfolioChange"
            >
              <a-select-option v-for="item in portfolios" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Base" name="base" v-if="user?.customer.enable_bases === true">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.base"
              placeholder="Seleccione una base"
            >
              <a-select-option v-for="item in bases" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Tipo de archivos" name="type_import">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.type_import"
              placeholder="Seleccionar tipo de archivo"
            >
              <a-select-option :key="ImportType.Clients"> Contactos </a-select-option>
              <a-select-option :key="ImportType.Products"> Productos </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Tipo de asignación" name="type_assignment">
            <a-select
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model:value="formState.type_assignment"
              placeholder="Seleccionar tipo de asignación"
            >
              <a-select-option :key="ImportAssignmentType.AddNewByAssignment">
                <a-popover
                  :title="`Agrega nuevos ${selectedImportItemText}`"
                  trigger="hover"
                  placement="rightBottom"
                >
                  <template #content>
                    <div class="container__text">
                      Agrega nuevos
                      {{
                        selectedImportItemText === "contactos"
                          ? "contactos a"
                          : "productos a tus contactos existentes en"
                      }}
                      tu CRM.
                    </div>
                  </template>

                  <div style="width: 100%">Agrega nuevos {{ selectedImportItemText }}</div>
                </a-popover>
              </a-select-option>

              <a-select-option :key="ImportAssignmentType.ByAssignment">
                <a-popover
                  :title="`Actualiza ${selectedImportItemText} existentes`"
                  trigger="hover"
                  placement="rightBottom"
                >
                  <template #content>
                    <div class="container__text">
                      Cambia o agrega nuevos datos de {{ selectedImportItemText }} ya existentes en
                      tu CRM.
                    </div>
                  </template>

                  <div style="width: 100%">Actualiza {{ selectedImportItemText }} existentes</div>
                </a-popover>
              </a-select-option>

              <a-select-option :key="ImportAssignmentType.Random">
                <a-popover
                  :title="`Restablece ${selectedImportItemText}`"
                  trigger="hover"
                  placement="rightBottom"
                >
                  <template #content>
                    <div class="container__text">
                      Mantiene activos únicamente los {{ selectedImportItemText }} de este archivo.
                    </div>
                  </template>

                  <div style="width: 100%">Restablece {{ selectedImportItemText }}</div>
                </a-popover>
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-alert v-if="showAlert" style="margin-bottom: 20px" type="info" show-icon>
        <template #message>
          <strong>Restablece contactos:</strong> Recuerda que solo se mantendrán en tu campaña los
          contactos actualmente importados. Los contactos ya existentes en tu CRM procederán a
          inactivarse.
        </template>
      </a-alert>

      <div class="picker__wrapper">
        <!-- <span>Carga tu archivo aquí</span> -->
        <a-form-item label="Carga tu archivo aquí" required>
          <archive-picker :value="file" @update:value="file = $event" :maxMBSize="5" />
        </a-form-item>
      </div>
    </a-form>

    <template v-slot:footer>
      <a-button key="back" @click="handleReturnModal"> Volver </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        id="import-template-button"
        :disabled="!file"
        @click="handleOk"
      >
        Importar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { fetchPortfolios, fetchAllBases } from "@/app/entities/services";

import ArchivePicker from "@/app/shared/components/molecules/ArchivePicker.vue";
import { ImportType, ImportAssignmentType } from "@/app/imports/utils/enums";
import { defineComponent, ref, reactive, toRaw, computed, createVNode } from "vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    ArchivePicker,
  },
  props: {
    modelValue: {
      required: true,
      type: Boolean,
    },
    isTypeBusiness: {
      required: true,
      type: Boolean,
    },
    openModal: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    const formRef = ref();
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);

    const formState = reactive({
      entity: undefined,
      portfolio: undefined,
      base: undefined,
      type_import: undefined,
      type_assignment: undefined,
    });
    const rules = {
      entity: [{ required: true, message: "Campo requerido" }],
      portfolio: [{ required: true, message: "Campo requerido" }],
      base: [{ required: true, message: "Campo requerido" }],
      type_import: [{ required: true, message: "Campo requerido" }],
      type_assignment: [{ required: true, message: "Campo requerido" }],
    };
    return {
      formRef,
      formState,
      rules,
      user,
    };
  },
  data() {
    return {
      ImportType,
      ImportAssignmentType,
      file: undefined,
      portfolios: [],
      bases: [],
      loading: false,
    };
  },
  computed: {
    entities() {
      return this.$store.getters["getEntityList"];
    },
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.handleResetForm();
        this.$emit("update:modelValue", value);
      },
    },
    selectedImportItemText() {
      const importItem = this.formState.type_import;

      if (importItem === ImportType.Clients) return "contactos";
      if (importItem === ImportType.Products) return "productos";

      return "";
    },
    showAlert() {
      const assignType = this.formState.type_assignment;
      const importItem = this.formState.type_import;

      return assignType === ImportAssignmentType.Random && importItem === ImportType.Clients;
    },
  },
  created() {
    if (this.isTypeBusiness) {
      this.formState.entity = this.entities.find((item) => item.is_owner).id;
      this.fetchPortfolios();
    }
  },
  methods: {
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleOk() {
      this.formRef.validateFields().then(() => {
        const values = toRaw(this.formState);
        const data = { ...values, file_import: this.file };
        this.uploadData(data);
      });
    },
    async uploadData(data) {
      this.loading = true;

      try {
        await this.$store.dispatch("importClientProductsTemplate", data);
        this.$emit("onHideModalProducts");
      } catch (error) {
        this.$message.error("Ha ocurrido un error");
      }

      this.loading = false;
    },
    async fetchPortfolios() {
      const response = await fetchPortfolios("", "", this.formState.entity);
      this.portfolios = response.results;
    },
    async fetchBases() {
      const response = await fetchAllBases(
        "",
        this.formState.entity,
        this.formState.portfolio,
        {},
        "1"
      );
      this.bases = response.results;

      if (!this.user?.customer.enable_bases) {
        this.formState.base = this.bases[0].id;
      }
    },
    handleEntityChange() {
      this.formState.portfolio = undefined;
      this.formState.base = undefined;
      this.fetchPortfolios();
    },
    handlePortfolioChange() {
      this.formState.base = undefined;
      this.fetchBases();
    },
    handleTypeStrategyChange(value) {
      this.typeStrategy = value;
    },
    handleCancel() {
      this.handleResetForm();
      this.$emit("onHideModalProducts");
    },
    handleResetForm() {
      this.formRef.resetFields();
      this.portfolios = [];
      this.bases = [];
      this.file = undefined;
    },
    handleReturnModal() {
      this.$emit("onReturnModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.type-select
  margin-top: 20px

.form
  color: $gray-9
  display: block
  max-width: 640px
  margin: 0 auto
  justify-content: space-between

.picker
  &__wrapper
    // max-width: 420px
    // margin-top: 20px
    // margin-bottom: 20px

.ant-form-item
  margin-bottom: 20px

.selects
  margin-right: 20px

.ant-alert
  align-items: flex-start
  color: $gray-8

:deep(.ant-alert-icon)
    margin-top: 4px

.container
  width: 480px
  height: 160px
  margin: 32px auto 32px auto
  border: 1px dashed $gray-6
  cursor: pointer
  text-align: center

.container__group
  margin-top: 20px

.container__text
  margin-bottom: 3px
  width: 220px
</style>
